import { Component, EventEmitter, Output, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import {CordovaService} from "@cbcore/services/utils/cordova/cordova.service";
import {ImageService} from "@cbcore/services/utils/image/image.service";

import {TranslocoModule} from "@jsverse/transloco";
import {AvatarCroppieComponent} from "../avatar-croppie/avatar-croppie";

@Component({
    selector: 'avatar-uploader',
    templateUrl: './avatar-uploader.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, AvatarCroppieComponent]
})

export class AvatarUploaderComponent {

  public file: File | null = null;

  public error : boolean = false;
  public errorType!: string;
  public loading: boolean = false;
  private readonly maxFileSize: number = 3000000; // matches the 3MB limit stated in errors.MANAGER_FILE_TOO_BIG

  public croppedImage: boolean = false;
  public android: boolean = false;

  @ViewChild('inputFile') inputFile!: ElementRef;
  @Output()fileDetected : EventEmitter<any> = new EventEmitter();
  @Output()isCropping : EventEmitter<boolean> = new EventEmitter();
  @Output()fileError : EventEmitter<boolean> = new EventEmitter(); // true while an invalid file (type/size) is rejected, false once cleared

  constructor(
    private _imageService: ImageService,
    private _cordovaService: CordovaService
  ) { }

  ngOnInit(): void {
    this.android = this._cordovaService.isAndroid();
  }

  handleSelect(event: any): void {
    event.preventDefault();
    event.stopPropagation();
    const file: File = event.target.files[0];
    this.checkFile(file);
  }

  handleSelectCordova(): void {
    this._imageService.uploadImage('BASE').then((imageData) => {
      this.checkFile(imageData?.file?.name[0]);
    });
  }

  checkFile(file: any): void {
    this.error = false;
    this.fileError.emit(false);

    if (file && file.type) {
      const type: string = file.type.split('/')[1];
      const size: number = file.size;

      if (type !== 'jpeg' && type !== 'png') {
        this.error = true;
        this.errorType = 'TYPE';
        this.fileError.emit(true);
      } else if (size > this.maxFileSize) {
        this.error = true
        this.errorType = 'SIZE';
        this.fileError.emit(true);
      } else {
        this.file = file;
        this.isCropping.emit(true);
      }
    }
    this.loading = false;
  }

  handleAvatarCropped(event: any): void {
    this.croppedImage = true;
    this.file = null;
    this.fileDetected.emit(event);
    this.isCropping.emit(false);
  }

  fileCanceled(e: Event): void {
    this.file = null;
    this.isCropping.emit(false);
  }

  ngOnDestroy(): void {
    this.loading = false;
  }
}
